import React from 'react';
import './Pricing.css';

function Pricing() {
  const plans = [
    {
      name: '基础版',
      price: '¥99',
      period: '/月',
      description: '适合个人用户和小型项目',
      features: [
        'AI 绘图：10 张/月',
        'AI 写作：5,000 字/月',
        'AI Logo：1 个/月',
        '标准质量输出',
        '邮件支持'
      ],
      popular: false
    },
    {
      name: '专业版',
      price: '¥299',
      period: '/月',
      description: '适合专业创作者和中小企业',
      features: [
        'AI 绘图：50 张/月',
        'AI 写作：20,000 字/月',
        'AI Logo：5 个/月',
        '高质量输出',
        '优先处理',
        '7x24 小时支持',
        '商业使用授权'
      ],
      popular: true
    },
    {
      name: '企业版',
      price: '¥999',
      period: '/月',
      description: '适合大型企业和团队',
      features: [
        'AI 绘图：无限',
        'AI 写作：无限',
        'AI Logo：无限',
        '最高质量输出',
        '专属客户经理',
        'API 接口访问',
        '自定义模型训练',
        '团队协作功能',
        'SLA 保障'
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing" className="pricing section">
      <div className="container">
        <div className="pricing__header">
          <h2 className="section__title">灵活的定价方案</h2>
          <p className="section__subtitle">
            选择最适合您需求的方案，随时可升级或降级
          </p>
        </div>

        <div className="pricing__grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? 'pricing-card--popular' : ''}`}
            >
              {plan.popular && (
                <div className="pricing-card__badge">最受欢迎</div>
              )}
              
              <div className="pricing-card__header">
                <h3 className="pricing-card__name">{plan.name}</h3>
                <p className="pricing-card__description">{plan.description}</p>
                <div className="pricing-card__price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">{plan.period}</span>
                </div>
              </div>

              <div className="pricing-card__features">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="pricing-feature">
                    <span className="pricing-check">✓</span>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <button className={`btn ${plan.popular ? 'btn--primary' : 'btn--outline'} btn--block`}>
                开始使用
              </button>
            </div>
          ))}
        </div>

        <div className="pricing__faq">
          <h3 className="faq-title">常见问题</h3>
          <div className="faq-list">
            <div className="faq-item">
              <h4>可以按需付费吗？</h4>
              <p>可以，我们提供按量计费的选项。AI 绘图 ¥29/张，AI 写作 ¥0.1/字，AI Logo ¥199/套。</p>
            </div>
            <div className="faq-item">
              <h4>支持退款吗？</h4>
              <p>支持 7 天无理由退款。如果您对服务不满意，可以随时申请全额退款。</p>
            </div>
            <div className="faq-item">
              <h4>商业使用需要额外授权吗？</h4>
              <p>专业版和企业版已包含商业使用授权。基础版仅限个人使用，商业使用需升级。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;

